(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delan-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delan-engraving')) {
    customElements.define('delan-engraving', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const setup = () => {
          this.fields = this.querySelector('fieldset');
          this.styleInput = this.querySelector('[data-engraving-style]');
          this.textInput = this.querySelector('[data-engraving-text]');
          this.variants = JSON.parse(this.querySelector('[data-engraving-variants]').textContent);
          this.optionIndex = Number(this.dataset.optionIndex);
          const signal = this.controller.signal;
          document.addEventListener('change', event => {
            if (event.target.closest('variant-selects') && this.closest('product-info')?.contains(event.target)) this.syncSelection();
            if (event.target.name === 'id' && event.target.form?.id === this.dataset.formId) this.sync();
          }, { capture: true, signal });
          document.addEventListener('variant:change', event => {
            if (event.target.id === this.dataset.formId) this.sync();
          }, { capture: true, signal });
          this.textInput.addEventListener('input', () => this.textInput.setCustomValidity(''), { signal });
          document.addEventListener('click', event => {
            const link = event.target.closest('.wa-price-btn');
            if (link && this.closest('.shopify-section')?.contains(link) && !this.validate()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          }, { capture: true, signal });
          document.addEventListener('submit', event => {
            if (event.target.id === this.dataset.formId && !this.validate()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          }, { capture: true, signal });
          this.syncSelection();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true, signal: this.controller.signal });
        else setup();
      }
      isYes(value) { return /^(yes\b|with engraving\b)/i.test(value || ''); }
      currentVariant() {
        const id = document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]')?.value;
        const selectedById = this.variants.find(variant => String(variant.id) === id);
        if (selectedById) return selectedById;
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        const values = [];
        picker?.querySelectorAll('[data-option-index]').forEach(group => {
          const control = group.querySelector('select, input:checked');
          const position = Number(group.dataset.optionIndex.replace('option', '')) - 1;
          if (control) values[position] = control.value;
        });
        return this.variants.find(variant => values.length === variant.options.length && variant.options.every((value, index) => value === values[index]));
      }
      syncSelection() {
        const form = document.getElementById(this.dataset.formId);
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        const input = form?.querySelector('input[name="id"]');
        const values = [];
        picker?.querySelectorAll('[data-option-index]').forEach(group => {
          const control = group.querySelector('select, input:checked');
          const position = Number(group.dataset.optionIndex.replace('option', '')) - 1;
          if (control) values[position] = control.value;
        });
        const variant = this.variants.find(item => values.length === item.options.length && item.options.every((value, index) => value === values[index]));
        if (variant && input && input.value !== String(variant.id)) {
          input.value = String(variant.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
      }
      sync() {
        const variant = this.currentVariant();
        const enabled = Boolean(variant && this.isYes(variant.options[this.optionIndex]));
        this.fields.disabled = !enabled;
        this.styleInput.required = enabled;
        this.textInput.required = enabled;
        this.querySelector('[data-engraving-hint]').hidden = enabled;
        const cost = this.querySelector('[data-engraving-cost]');
        const plain = variant && this.variants.find(item => !this.isYes(item.options[this.optionIndex]) && item.options.every((value, index) => index === this.optionIndex || value === variant.options[index]));
        cost.hidden = !enabled || !plain;
        if (enabled && plain) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency }).format((variant.price - plain.price) / 100);
          cost.textContent = `${this.dataset.costLabel} +${amount}`;
        }
        if (!enabled) {
          this.styleInput.value = '';
          this.textInput.value = '';
          this.textInput.setCustomValidity('');
        }
      }
      validate() {
        this.syncSelection();
        if (this.fields.disabled) return true;
        if (!this.styleInput.reportValidity()) return false;
        if (!this.textInput.value.trim()) this.textInput.value = '';
        return this.textInput.reportValidity();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delan-extra-strap"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('delan-extra-strap')) customElements.define('delan-extra-strap',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();
  const setup=()=>{
   this.input=this.querySelector('select:not([data-add-strap])');
   this.add=this.querySelector('[data-add-strap]');
   this.colours=this.querySelector('[data-strap-colours]');
   this.add.addEventListener('change',()=>{this.input.value='';this.colours.hidden=this.add.value!=='yes';this.input.disabled=this.add.value!=='yes';this.input.required=this.add.value==='yes';this.choose();},{signal:this.controller.signal});
   this.variants=JSON.parse(this.querySelector('script').textContent);
   this.optionIndex=1;
   this.property=this.querySelector('input');
   this.input.addEventListener('change',()=>this.choose(),{signal:this.controller.signal});
   const signal=this.controller.signal;
   document.addEventListener('change',e=>{
    if(e.target.closest('variant-selects')&&this.closest('product-info')?.contains(e.target))this.syncSelection();
    if(e.target.name==='id'&&e.target.form?.id===this.dataset.formId)this.sync();
   },{capture:true,signal});
   document.addEventListener('variant:change',e=>{if(e.target.id===this.dataset.formId)this.sync();},{capture:true,signal});
   document.addEventListener('submit',e=>{if(e.target.id===this.dataset.formId&&!this.validate()){e.preventDefault();e.stopImmediatePropagation();}},{capture:true,signal});
   document.addEventListener('click',e=>{
    const link=e.target.closest('.wa-price-btn');
    if(!link||!this.closest('.shopify-section')?.contains(link))return;
    if(!this.validate()){e.preventDefault();e.stopImmediatePropagation();return;}
    const url=new URL(link.href);
    let msg=(url.searchParams.get('text')||'').replace(/\nExtra strap colour:.*$/m,'');
    if(!this.property.disabled)msg+='\nExtra strap colour: '+this.property.value;
    url.searchParams.set('text',msg);link.href=url.href;
   },{capture:true,signal});
   this.syncSelection();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true,signal:this.controller.signal});else setup();
 }
      currentVariant() {
        const id = document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]')?.value;
        return this.variants.find(variant => String(variant.id) === id);
      }
      syncSelection() {
        const form = document.getElementById(this.dataset.formId);
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        const input = form?.querySelector('input[name="id"]');
        const values = [];
        picker?.querySelectorAll('[data-option-index]').forEach(group => {
          const control = group.querySelector('select, input:checked');
          const position = Number(group.dataset.optionIndex.replace('option', '')) - 1;
          if (control) values[position] = control.value;
        });
        const variant = this.variants.find(item => values.length === item.options.length && item.options.every((value, index) => value === values[index]));
        if (variant && input && input.value !== String(variant.id)) {
          input.value = String(variant.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
      }

 native(){
  return this.closest('product-info')?.querySelector('variant-selects [data-option-index="option2"] select');
 }
 choose(){
  const native=this.native();
  if(!native)return;
  const colour=this.add.value==='no'?'__none':this.input.value;
  const option=Array.from(native.options).find(o=>colour==='__none'?o.value.startsWith('No'):colour==='Blue Camouflage'?o.value.includes('Blue Camouflage'):o.value.startsWith('Add additional')&&!o.value.includes('Blue Camouflage'));
  if(!option)return;
  this.property.value=colour==='__none'?'':colour;
  this.property.disabled=colour==='__none';
  if(native.value!==option.value){
   native.value=option.value;
   native.dispatchEvent(new Event('change',{bubbles:true}));
  }
  this.syncSelection();
 }
 sync(){
  const native=this.native();
  if(!native)return;
  native.closest('[data-option-index]').hidden=true;
  native.closest('[data-option-index]').style.display='none';
  this.hidden=false;this.input.disabled=false;
  const variant=this.currentVariant();
  const value=native.value||variant?.options[1]||'';
  const no=value.startsWith('No');
  const camo=value.includes('Blue Camouflage');
  this.add.value=no?'no':'yes';
  this.colours.hidden=no;this.input.disabled=no;this.input.required=!no;
  if(no)this.input.value='';
  else if(camo)this.input.value='Blue Camouflage';
  else if(['__none','Blue Camouflage'].includes(this.input.value))this.input.value='';
  this.property.value=no?'':this.input.value;
  this.property.disabled=no||!this.input.value;
 }
 validate(){this.syncSelection();return this.input.disabled||this.input.reportValidity();}

 disconnectedCallback(){this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delan-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delan-name-review')) {
  customElements.define('delan-name-review', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const fields = Array.from(document.querySelectorAll('input')).filter(input => input.form?.getAttribute('id') === this.dataset.form && input.name.startsWith('properties[Name'));
        const names = fields.map(input => input.value.trim()).filter(Boolean);
        this.hidden = !names.length;
        this.querySelector('span').textContent = names.join(' + ');
      };
      document.addEventListener('input', this.update);
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('input', this.update); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delan-ui"] && !Shopify.designMode) return;
  try {
    (()=>{
    const dialog=document.getElementById('DelanWishlist');
    if(!dialog)return;
    const key='delan.wishlist.v1';let saved=[],storageWorks=true;
    const valid=p=>p&&typeof p.handle==='string'&&typeof p.title==='string'&&typeof p.url==='string'&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/i.test(p.url);
    function read(){try{const value=JSON.parse(localStorage.getItem(key)||'[]');saved=Array.isArray(value)?value.filter(valid).slice(0,100):[];}catch{saved=[];storageWorks=false;}}
    function sync(){document.querySelectorAll('[data-delan-save]').forEach(b=>{const active=saved.some(p=>p.handle===b.dataset.delanSave);b.setAttribute('aria-pressed',String(active));const icon=b.querySelector('[aria-hidden]'),symbol=active?'♥':'♡';if(icon.textContent!==symbol)icon.textContent=symbol;});}
    function render(){const list=dialog.querySelector('[data-delan-list]');list.replaceChildren();saved.forEach(p=>{const li=document.createElement('li'),a=document.createElement('a'),b=document.createElement('button');a.href=p.url;a.textContent=p.title;b.type='button';b.dataset.delanRemove=p.handle;b.textContent=dialog.dataset.remove;b.setAttribute('aria-label',dialog.dataset.remove+' '+p.title);li.append(a,b);list.append(li);});dialog.querySelector('[data-delan-status]').textContent=!storageWorks?dialog.dataset.unavailable:(!saved.length?dialog.dataset.empty:'');sync();}
    function persist(){try{localStorage.setItem(key,JSON.stringify(saved));}catch{storageWorks=false;}render();}
    document.addEventListener('click',e=>{const save=e.target.closest('[data-delan-save]'),open=e.target.closest('[data-delan-open]'),remove=e.target.closest('[data-delan-remove]');if(save){const p={handle:save.dataset.delanSave,title:save.dataset.title,url:save.dataset.url};if(!valid(p))return;const i=saved.findIndex(x=>x.handle===p.handle);if(i>=0)saved.splice(i,1);else if(saved.length<100)saved.push(p);persist();}if(open){render();dialog.showModal();}if(remove){saved=saved.filter(p=>p.handle!==remove.dataset.delanRemove);persist();}if(e.target.closest('[data-delan-close]'))dialog.close();if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    window.addEventListener('storage',e=>{if(e.key===key){read();render();}});document.addEventListener('shopify:section:load',sync);
    const observer=new MutationObserver(sync);observer.observe(document.getElementById('MainContent'),{childList:true,subtree:true});
    read();render();
  })();
  } catch(e) { console.error(e); }
})();

})();
